import { ListColumns } from "../enum/list-columns";
import { IFetchListsResponseDto } from "../interface/dto/lists.dto";
import { ISelectedFilters } from "../interface/selected-filters";
import {
    IDataBrowserListActions,
    DataBrowserListActionTypes,
} from "./lists.actions";

export interface IDataBrowserListState {
    filters: ISelectedFilters;
    columns: Array<ListColumns>;
    lists?: IFetchListsResponseDto;
    isLoading: boolean;
    error?: string;
    pagination: {
        currentPage: number;
        itemsPerPage: number;
    };
    sorting: {
        column: ListColumns;
        order: "asc" | "desc";
    };
    selectAll: boolean;
    selectedListIds: Array<number>;
}

const initDataBrowserListState: IDataBrowserListState = {
    filters: {},
    columns: [
        ListColumns.LIST_ID,
        ListColumns.NAME,
        ListColumns.CATEGORY,
        ListColumns.RECORDS,
    ],
    isLoading: false,
    pagination: {
        currentPage: 1,
        itemsPerPage: 10,
    },
    sorting: {
        column: ListColumns.NAME,
        order: "asc",
    },
    selectAll: false,
    selectedListIds: [],
};

export const dataBrowserListReducer = (
    state = initDataBrowserListState,
    action: IDataBrowserListActions,
): IDataBrowserListState => {
    switch (action.type) {
        case DataBrowserListActionTypes.DATABROWSER_LIST_INIT:
            return {
                ...state,
                ...initDataBrowserListState,
            };

        case DataBrowserListActionTypes.DATABROWSER_LIST_SET_FILTERS:
            return {
                ...state,
                filters: action.payload.filters,
                selectAll: false,
                selectedListIds: [],
                pagination: {
                    ...state.pagination,
                    currentPage: 1,
                },
            };
        case DataBrowserListActionTypes.DATABROWSER_LIST_RESET_FILTERS:
            return {
                ...state,
                filters: {},
                selectAll: false,
                selectedListIds: [],
                pagination: {
                    ...state.pagination,
                    currentPage: 1,
                },
            };
        case DataBrowserListActionTypes.DATABROWSER_LIST_SET_COLUMNS:
            return { ...state, columns: action.payload };
        case DataBrowserListActionTypes.DATABROWSER_LIST_LOAD_LISTS:
            return {
                ...state,
                isLoading: true,
                error: undefined,
            };
        case DataBrowserListActionTypes.DATABROWSER_LIST_LOAD_LISTS_SUCCESS:
            return { ...state, isLoading: false, lists: action.payload };
        case DataBrowserListActionTypes.DATABROWSER_LIST_LOAD_LISTS_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error,
                lists: undefined,
            };
        case DataBrowserListActionTypes.DATABROWSER_LIST_SET_PAGINATION:
            return {
                ...state,
                pagination: {
                    ...action.payload,
                    currentPage:
                        action.payload.itemsPerPage !==
                        state.pagination.itemsPerPage
                            ? 1
                            : action.payload.currentPage,
                },
            };
        case DataBrowserListActionTypes.DATABROWSER_LIST_SET_SORTING:
            return { ...state, sorting: action.payload };
        case DataBrowserListActionTypes.DATABROWSER_SELECT_ALL_TOGGLE:
            return {
                ...state,
                selectedListIds: [],
                selectAll: !state.selectAll,
            };
        case DataBrowserListActionTypes.DATABROWSER_SELECT_LIST_TOGGLE: {
            const { listId } = action.payload;
            let selectAll = state.selectAll;
            let selectedListIds = state.selectedListIds.includes(listId)
                ? state.selectedListIds.filter((id) => id !== listId)
                : [...state.selectedListIds, listId];
            if (selectedListIds.length === state.lists?.total) {
                selectedListIds = [];
                selectAll = !selectAll;
            }
            return {
                ...state,
                selectAll,
                selectedListIds,
            };
        }
        default:
            return state;
    }
};
